import { config } from "zod";

// The web app ships with a strict CSP that intentionally omits `unsafe-eval`.
// Zod's default object-schema fast path probes for JIT support with
// `new Function("")`; although Zod catches the resulting exception, browsers
// still report it as a CSP violation. Configure Zod before modules that create
// schemas (including Better Auth) are evaluated so the probe is never run.
config({ jitless: true });
